import { LocalizationStrings } from "./LocalizationData";

const LocalizationLanguageFi: LocalizationStrings = {
	lang_nativeName: 'Suomi',
	lang_selectionName: 'Suomeksi',
	lang_selectionTitle: 'Kielen valinta',
	lang_selectionAccept: 'Hyväksy',
	
	button_close: 'Sulje',

	home_title: 'Tervetuloa E-Spiral-lomakkeeseen',
	home_description: `E-Spiral-lomake on sähköinen versio Spiral-menetelmän vastauslomakkeesta, jolla voit arvioida toimintakykyäsi. E-Spiral-lomakkeen tarkoituksena on auttaa sinua jäsentämään ja löytämään kuntoutumiseen liittyviä tavoitteitasi.<br/><br/>Lomake täytetään nimettömänä. Lopuksi sinulta kysytään muutamia taustatietoja, joita hyödynnetään menetelmän jatkokehittämisessä. Täyttämisen jälkeen saat koodin ja linkin, joiden avulla voit tarkastella tuloksiasi 3 kuukauden ajan sekä jakaa ne haluamallesi taholle.<br/><br/>Lomakkeen täyttäminen vie noin 10-15 minuuttia.`,
	home_description_link: `E-Spiral-lomaketta voit käyttää itsenäisesti ilman varsinaista Spiral-peliä. Tutustu halutessasi tarkemmin koko pelilliseen Spiral-menetelmään tästä.`,
	home_startQuestionnaire_button: 'Aloita kysely',
	home_resultOpener_title: 'Syötä tuloskoodi',
	home_resultOpener_submit: 'Hae tulokset',
	home_resultOpener_error_invalidFormat: 'Vääränmuotoinen tuloskoodi',
	home_resultOpener_button: 'Tulitko katsomaan tuloksia?',

	question_answerQuestion_error: 'Vastaa jokaiseen kohtaan voidaksesi jatkaa eteenpäin',
	question_help_title: 'Ohjeet',

	button_next: 'Seuraava',
	button_previous: 'Edellinen',
	button_save: 'Tallenna muutokset',

	preliminary_title: 'Taustatiedot',
	preliminary_description: `Lopuksi voit antaa itsestäsi joitakin taustatietoja. Jokaisen kysymyksen kohdalla valitse yksi parhaiten sopiva vaihtoehto. Älä kirjoita avoimiin kenttiin nimeäsi tai muuta henkilökohtaista tietoa.`,

	preliminary_form_answer_noAnswer: "en halua vastata",
	preliminary_form_other_text: "Tarkenna vastaustasi:",

	preliminary_age_title: 'Ikä:',
	preliminary_answer_age_title: 'Ikä:',

	preliminary_gender_title: 'Sukupuoli:',
	preliminary_answer_gender_title: 'Sukupuoli:',

	preliminary_gender_choices: {
		male: 'mies',
		female: 'nainen',
		other: 'muu'
	},

	preliminary_firstLanguage_title: 'Äidinkieli:',
	preliminary_answer_firstLanguage_title: 'Äidinkieli:',
	preliminary_firstLanguage_choices: {
		fi: "suomi",
		sv: "ruotsi",
		other: "jokin muu, mikä?"
	},

	preliminary_education_title: 'Korkein suorittamasi tutkinto:',
	preliminary_answer_education_title: 'Korkein suoritettu tutkinto:',

	preliminary_fillReason_title: 'Miksi täytit kyselyn?',
	preliminary_answer_fillReason_title: 'Täytön syy:',

	preliminary_fillReason: {
		self: 'omasta mielenkiinnosta',
		TE: 'ammattilaisen pyynnöstä TE-palveluissa',
		hc: 'ammattilaisten pyynnöstä terveydenhuollossa',
		edu: 'ammattilaisen pyynnöstä oppilaitoksessa',
		kela: 'ammattilaisen pyynnöstä Kelan palveluissa',
		org: 'ammattilaisen pyynnöstä 3. sektorilla (esim. järjestöt ja säätiöt)',
		testing: 'tutustun kyselyyn kokeilemalla vastaamista',
		other: 'muusta syystä',
	},

	preliminary_activity_title: 'Mikä on tällä hetkellä pääasiallinen toimintasi? Valitse parhaiten sopiva vaihtoehto.',
	preliminary_answer_activity_title: 'Pääasiallinen toiminta:',
	
	preliminary_activity: {
		student: 'koululainen tai opiskelija',
		employed: 'työsuhteessa tai yrittäjänä (myös osa-aikainen työ)',
		supportedWork: 'tuetussa työssä (esim. työpajassa, työharjoittelussa, työkokeilussa)',
		leave: 'pitkällä sairauslomalla tai kuntoutustuella',
		unemployed: 'työtön',
		paternityservice: 'vanhempainvapaalla tai armeijassa',
		retired: 'eläkkeellä (esim. vanhuus- tai tykyvyttömyyseläke)',
		other: 'jokin muu, mikä?'
	},

	preliminary_education_choices: {
		publicSchool: 'peruskoulu',
		upperSecondarySchool: 'ylioppilastutkinto',
		vocationalSchool: 'ammatillinen tutkinto (2. aste)',
		appliedSciencesUniversity: 'ammattikorkeakoulututkinto',
		university: 'yliopistotutkinto',
		other: 'muu, mikä?'
	},


	finish_sendResults: 'Lähetä tulokset',
	finish_noAnswer: 'ei vastausta',
	
	error_result: 'Tuloksen lataus epäonnistui',
	error_result_notFound: 'Tulosta ei löytynyt',
	error_generic: 'Jokin meni pieleen',

	button_tryAgain: 'Yritä uudelleen',
	button_toHome: 'Takaisin etusivulle',

	terms_title: 'Käyttöehdot',
	terms_button_accept: 'Hyväksyn käyttöehdot',

	reset_title: 'Hei',
	reset_body: 'Näyttäisi, että sinulla on kysely keskeneräisenä. Haluatko jatkaa sitä?',

	button_yes: 'Kyllä',
	button_no: 'En',

	button_start: 'Aloita',
	button_cancel: 'Peruuta',
	start_description: 'Haluatko aloittaa kyselyn?',

	button_endQuestionnaire: 'Lopeta kysely',
	endQuestionnaire_title: 'Haluatko varmasti lopettaa kyselyn?',

	button_send: 'Siirry tuloksiin',

	finish_title: 'Yhteenveto',
	finish_description_start: `Valitse alla näkyvistä vastauksistasi 1-3 tärkeintä, joihin tavoittelet muutosta.`,
	finish_description: `Halutessasi voit myös muuttaa aikaisempaa vastaustasi klikkaamalla vastauslaatikkoa. Vastauksesi vaihtamisen jälkeen pääset takaisin yhteenvetosivulle klikkaamalla ”Yhteenvetoon”-painiketta. Kun olet valmis, valitse ”Siirry tuloksiin”. Näin saat koodin ja linkin, joiden avulla voit tarkastella 3 kuukauden ajan tuloksiasi sekä jakaa ne haluamallesi taholle.`,

	finish_answers_title: 'Vastaukset',
	finish_highlightError: 'Sinun täytyy valita vähintään yksi kysymys tavoitteeksi',
	
	finish_highlight: 'Merkitse tavoitteeksi',
	finish_unhighlight: 'Poista tavoitteista',

	button_shareResult: 'Jaa tai tallenna tulos...',
	button_copyUrl: 'Kopioi linkki',
	button_copyCode: 'Kopioi koodi',
	resultSharing_title: 'Tulosten jako',
	resultSharing_urlShare: 'Alla olevalla linkillä voit jakaa tuloksesi muille',
	resultSharing_codeShare: 'Alla olevalla koodilla voit jakaa tuloksesi muille',

	resultSharing_survey: 'Mitä pidit E-Spiralista?',

	resultSharing_description: `Säilytämme tuloksiasi kolme kuukautta. Voit tarkastella niitä myöhemmin alla olevalla linkillä tai koodilla. Voit jakaa ne haluamallesi taholle liittämällä linkin/koodin sähköpostiviestiin (liitä painamalla Ctrl + V tai hiiren oikea näppäin + Liitä)`,

	
	resultSharing_urlShare_copied: 'Linkki kopioitu',
	resultSharing_codeShare_copied: 'Koodi kopioitu',
	
	answers_title: 'Tulokset',
	answers_answers_title: 'Muut osiot',
	answers_resultCode: 'Säilytämme tuloksiasi 3 kuukautta. Tuloskoodi:',
	answers_resultCode_end: 'Ota koodi talteen!',
	answers_target_title: 'Valitsemasi Spiral-tavoitteet',

	button_printPdf: 'Tulosta vastaukset',
	button_exit: 'Poistu',

	loading: 'Ladataan...',
	sending: 'Lähetetään...',

	questionnaireList_choose_title: 'Valitse kysely',

	button_toSummary: 'Yhteenvetoon',
	button_openPicture: 'Katso kuvaesimerkki',

	answers_secondary_answer_Value_texts: {
		'-1': 'En toivo muutosta asiaan',
		'0': 'En osaa sanoa',
		'1': 'Toivon muutosta asiaan'
	},
	button_instructions: 'Ohjeistus'
};

export default LocalizationLanguageFi;